import PaginationHandler from '../../common/search/PaginationHandler';
import PaginationFilter from '../../common/search/store/PaginationFilter';
import HouseSearchFilters from './store/HouseSearchFilters';

export default new PaginationHandler(
    document.querySelector('[data-role="pagination"]') as HTMLElement,
    HouseSearchFilters.getInstance().get(PaginationFilter.NAME) as PaginationFilter
);
